import React from "react";
import Template from "../../../components/Template";
import { useNavigate } from 'react-router-dom';

const Menus = () => {
    const navigate = useNavigate();

    const handleNavigateCadastrar = async (e) => {
        e.preventDefault();
        try {
            navigate('/configuracoes/menus');
        } catch (err) {
            console.error('Documentos Error:', err);
            alert(err.response?.data?.msg || 'Erro ao ir para o cadastro');
        }
    };

    const handleBack = () => {
        navigate('/configuracoes');
    };

    return (
        <Template>
            <form className="w-full px-4 py-6 flex flex-col gap-8">
                {/* Título da Página */}
                <div>
                    <h1 className="text-2xl text-stone-800 font-medium">Configurações</h1>
                </div>

                <div className="flex flex-col justify-start items-start gap-4 flex-wrap">
                    {/* Abaixo, cada 'botão' tem 'max-w-[240px]' */}
                    <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                        <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => {
                            navigate('/configuracoes/status');
                        }}>
                            Status
                        </button>
                    </div>
                    <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex items-center gap-2">
                        <button type="button" className="text-white text-sm font-medium font-['Inter'] leading-normal" onClick={() => {
                            navigate('/configuracoes/classificacao');
                        }}>
                            Classificação
                        </button>
                    </div>
                    <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex gap-2 justify-start">
                        <button
                            type="button"
                            className="w-full text-left text-white text-sm font-medium font-['Inter'] leading-normal"
                            onClick={() => {
                                navigate('/configuracoes/tipo');
                            }}
                        >
                            Tipo (Editais e Documentos)
                        </button>
                    </div>
                    <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex gap-2 justify-start">
                        <button
                            type="button"
                            className="w-full text-left text-white text-sm font-medium font-['Inter'] leading-normal"
                            onClick={() => {
                                navigate('/configuracoes/modalidade');
                            }}
                        >
                            Modalidade
                        </button>
                    </div>
                    <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex gap-2 justify-start">
                        <button
                            type="button"
                            className="w-full text-left text-white text-sm font-medium font-['Inter'] leading-normal"
                            onClick={() => {
                                navigate('/configuracoes/orgaoemissor');
                            }}
                        >
                            Órgão Emissor
                        </button>
                    </div>
                    <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex gap-2 justify-start">
                        <button
                            type="button"
                            className="w-full text-left text-white text-sm font-medium font-['Inter'] leading-normal"
                            onClick={() => {
                                navigate('/configuracoes/tipodocumento');
                            }}
                        >
                            Tipo Documento
                        </button>
                    </div>
                    <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex gap-2 justify-start">
                        <button
                            type="button"
                            className="w-full text-left text-white text-sm font-medium font-['Inter'] leading-normal"
                            onClick={() => {
                                navigate('/configuracoes/tipoobra');
                            }}
                        >
                            Tipo Obra
                        </button>
                    </div>
                    <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex gap-2 justify-start">
                        <button
                            type="button"
                            className="w-full text-left text-white text-sm font-medium font-['Inter'] leading-normal"
                            onClick={() => {
                                navigate('/configuracoes/categoriafornecedor');
                            }}
                        >
                            Categoria Fornecedor
                        </button>
                    </div>
                    <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex gap-2 justify-start">
                        <button
                            type="button"
                            className="w-full text-left text-white text-sm font-medium font-['Inter'] leading-normal"
                            onClick={() => {
                                navigate('/configuracoes/categoriadespesa');
                            }}
                        >
                            Categoria Despesa
                        </button>
                    </div>
                    <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex gap-2 justify-start">
                        <button
                            type="button"
                            className="w-full text-left text-white text-sm font-medium font-['Inter'] leading-normal"
                            onClick={() => {
                                navigate('/configuracoes/catalogo');
                            }}
                        >
                            Catálogo de Material/ Serviço
                        </button>
                    </div>
                    <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex gap-2 justify-start">
                        <button
                            type="button"
                            className="w-full text-left text-white text-sm font-medium font-['Inter'] leading-normal"
                            onClick={() => {
                                navigate('/configuracoes/prazoexecucao');
                            }}
                        >
                            Prazo Execução
                        </button>
                    </div>
                    <div className="w-full max-w-[240px] px-4 py-2 bg-stone-600 rounded-md inline-flex gap-2 justify-start">
                        <button
                            type="button"
                            className="w-full text-left text-white text-sm font-medium font-['Inter'] leading-normal"
                            onClick={() => {
                                navigate('/configuracoes/qualificacao');
                            }}
                        >
                            Qualificação
                        </button>
                    </div>
                </div>
                {/* Botões de Ação */}
                <div className="flex items-center w-full gap-4">
                    <div className="flex gap-4 ml-auto">
                        <button
                            type="button"
                            className="px-4 py-2 bg-stone-600 text-white text-sm font-medium rounded-md flex items-center gap-2"
                            onClick={handleBack}
                        >
                            <img className="w-4 h-4" src="/images/icon/arrow-left.png" alt="Voltar" />
                            <span>Voltar</span>
                        </button>

                    </div>
                </div>

            </form>
        </Template>
    );
};

export default Menus;
